import axios from "axios";

const state = {
  auditLogs: [],
  totalItems: 0,
  loading: false,
  error: null,
  currentPage: 1,
  pageSize: 10,
  eventTypes: [],
};

const getters = {
  getAuditLogs: (state) => state.auditLogs,
  getTotalItems: (state) => state.totalItems,
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
  getCurrentPage: (state) => state.currentPage,
  getPageSize: (state) => state.pageSize,
  getEventTypes: (state) => state.eventTypes
};

const mutations = {
  SET_AUDIT_LOGS(state, logs) {
    state.auditLogs = logs;
  },
  SET_TOTAL_ITEMS(state, total) {
    state.totalItems = total;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_PAGE_SIZE(state, size) {
    state.pageSize = size;
  },
  SET_EVENT_TYPES(state, eventTypes) {
    state.eventTypes = eventTypes;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  },
};

const actions = {
  async fetchAuditLogs({ commit }, payload) {
    commit("SET_LOADING", true);
    commit("CLEAR_ERROR");

    try {
      const response = await axios.post("/audit/list", {
        userAddress: payload.userAddress || null,
        eventType: payload.eventType || null,
        applyFrom: payload.applyFrom || null,
        applyUntil: payload.applyUntil || null,
        pageNum: payload.pageNum || 1,
        pageSize: payload.pageSize || 10,
      });

      if (response.data && response.status == 200) {
        commit("SET_AUDIT_LOGS", response.data.object.content || []);
        commit("SET_CURRENT_PAGE", payload.pageNum || 1);
        commit("SET_PAGE_SIZE", payload.pageSize || 10);

        return {
          success: true,
          data: response.data.object,
        };
      } else {
        const errorMsg = response.data?.message || "Failed to fetch audit logs";
        commit("SET_ERROR", errorMsg);
        return {
          success: false,
          message: errorMsg,
        };
      }
    } catch (error) {
      console.error("Error fetching audit logs:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Network error occurred";
      commit("SET_ERROR", errorMsg);

      return {
        success: false,
        message: errorMsg,
      };
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getEventTypeEnum({ commit }) {
    commit("SET_LOADING", true);
    commit("CLEAR_ERROR");

    try {
      const response = await axios.get(`/audit/event/type`);

      if (response.data && response.status == 200) {
        commit("SET_EVENT_TYPES", response.data.object.content);
        return {
          success: true,
          data: response.data.object,
        };
      } else {
        const errorMsg =
          response.data?.message || "Failed to fetch audit log details";
        commit("SET_ERROR", errorMsg);
        return {
          success: false,
          message: errorMsg,
        };
      }
    } catch (error) {
      console.error("Error fetching audit log details:", error);
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Network error occurred";
      commit("SET_ERROR", errorMsg);

      return {
        success: false,
        message: errorMsg,
      };
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // Action to clear audit logs
  clearAuditLogs({ commit }) {
    commit("SET_AUDIT_LOGS", []);
    commit("SET_TOTAL_ITEMS", 0);
    commit("CLEAR_ERROR");
  },

  // Action to set page parameters
  setPageParameters({ commit }, { page, size }) {
    if (page) commit("SET_CURRENT_PAGE", page);
    if (size) commit("SET_PAGE_SIZE", size);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
